export default {
  greeting: 'Hello this is home page',
  intro: 'Welcome to SaralWeb,We are a cutting-edge tech company dedicated to providing straightforward '
}
